import { useModuleBEM } from "@b2bportal/core-themes";
import { useI18nContext } from "@hopper-b2b/i18n";
import { getFaqLink } from "@hsbc/utilities";
import { CardList } from "./components";
import styles from "./styles.module.scss";

export const Cards = () => {
  const { t, language } = useI18nContext();
  const [block] = useModuleBEM(styles, "WalletCards");

  return (
    <div className={block}>
      <CardList />

      <span>{t("wallet.credits.learnMoreLabel")}</span>

      <a href={getFaqLink(language)} target="_blank" rel="noreferrer">
        {t("wallet.credits.faqButton")}
      </a>
    </div>
  );
};
